<template>
  <div class="magezine">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/" style="display:flex;align-items:center">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item>会刊信息</el-breadcrumb-item>
        <div style="display:flex;flex:1">
          <!-- <el-button type="primary" size="mini" @click="pullcatalog">获取上届会刊信息</el-button> -->
          <div  style="padding-top:10px;color:red;font-size:16px;margin-left:10px">特别提示：本届展会将不再印刷纸质会刊，请您填写、修改后点击下方按钮保存并提交，会刊内容将会收录在电子会刊中！</div>
        </div>
      </el-breadcrumb>
    </div>    
    <el-row>
      <el-col :span="18">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="magezineForm" label-position="right" label-width="240px">
            <template v-for="(item,ind) in allList">
              <template v-if="item.fieldKey != 'clgCountry' && item.fieldKey != 'clgProvince'  && item.fieldKey != 'clgCity' && item.fieldKey != 'clgPdtType' && item.fieldKey != 'clgLogo' && item.fieldKey != 'clgIfShowEmail' ">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <template v-if="item.fieldKey == 'clgTel' || item.fieldKey == 'clgFax' ">
                    <el-input v-model="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                </template>
                <template v-else>
                  <el-input v-if="item.fieldKey == 'clgIntro'" type="textarea"  v-model="form[item.fieldKey]" :placeholder="item.fieldHolder"  maxlength="500" show-word-limit @input="textChange()"></el-input>
                  <el-input v-else-if="item.fieldKey == 'clgEIntro'" type="textarea"  v-model="form[item.fieldKey]" :placeholder="item.fieldHolder"  maxlength="2000" show-word-limit></el-input>
                   <el-input v-else type="text"  v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" :disabled = 'item.fieldKey == "clgComName" || item.fieldKey == "clgComEName" '></el-input>
                </template>
                </el-form-item>
              </template>
              <!-- 主营产品 -->
              <template v-if="item.fieldKey == 'clgPdtType'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                    <el-cascader  v-model="form[item.fieldKey]" :options="tagOptions" :props="tagProps" separator="：" clearable  ></el-cascader>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'clgCountry'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <!-- <el-select v-model="form[item.fieldKey]" filterable :placeholder="item.fieldHolder" @change='changeCountry'>
                    <el-option
                      v-for="(item, index) in countryList"
                      :key="index"
                      :label="item.zptCity"
                      :value="item.zptCity">
                    </el-option>
                  </el-select> -->
                  <el-select v-model="form[item.fieldKey]" filterable :placeholder="item.fieldHolder" @change='changeCountry'>
                    <el-option v-for="(item, index) in countryList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>
                <template v-if="item.fieldKey == 'clgProvince'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeProvince' :disabled="provinceList.length<=0">
                    <el-option v-for="(item, index) in provinceList" :key="index" :label="item.zptProvince" :value="item.zptProvince"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'clgCity'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey"  :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" :disabled="cityList.length<=0">
                    <el-option v-for="(item, index) in cityList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'clgLogo'">
                  <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind"  class="clgLogo">
                      <el-input v-model="form[item.fieldKey]" style="display:none"/>
                      <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]" />
                      <!-- <div style="color:red">分辨率不低于150k，2M以内</div> -->
                      <div style="color:red">请确保您上传的logo避免带有白边以获得更佳展示效果。</div>
                  </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'clgIfShowEmail'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeCountry'>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </template> 
          </template>
          <!-- 是否在电子会刊里展示联系方式和邮箱 -->
          <!-- <template> 
            <div style="margin-left: 214px;">
              <el-checkbox v-model="isShowContactInfo">
                <span>是否在电子会刊里展示邮箱</span>
              </el-checkbox>
            </div>
          </template> -->
          <el-form-item>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit('1')" :disabled = 'Dsave'>暂存</el-button>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit('')" :disabled = 'saveBtnStatue'>提交</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-dialog
      title="保护知识产权声明"
      :visible.sync="dialogVisible"
      width="60%"
      :show-close='isClose'
      :close-on-click-modal='isClose'
      :close-on-press-escape='isClose'
      :modal-append-to-body='isClose'
      :append-to-body='isClose'
      :lock-scroll='isClose'>
      <div>
        <div class="tipContent">
          <div>为维护展览会的正常展览秩序，增强参展企业知识产权意识，保护参展单位的合法权益，根据中华人民共和国《商标法》、《专利法》、《著作权法》等相关规定，展览会组委会郑重声明如下:</div>
          <div>1、根据世界贸易组织《与贸易有关的知识产权协定》，知识产权包括：①版权及相关权利；②商标权；③地理标识权；④工业品外观设计权；⑤专利权；⑥集成电路布图设计（拓朴图）权；⑦对未透露之信息的保护权。凡以营利为目的，未经许可行使知识产权人享有的专有权利或其它给知识产权人的商业利益造成危害的不法行为，以及各种侵犯知识产权人精神权益的不法行为，均属于知识产权侵权行为。</div>
          <div>2、展览会组委会重视、尊重和保护参展单位的知识产权。展览会组委会有权对各参展单位加强管理、教育和监督检查。各参展单位要增强知识产权意识，做到参展展品不侵犯他人知识产权。</div>
          <div>3、为了创造良好的展示氛围，规避不必要的专利纠纷，展览会组委会特别委托专业机构对所有参展单位提交的会刊资料中所涉及的产品进行专利筛查，如发现参展单位填写的内容存在侵权风险，将向参展单位发放《展示产品专利预警》，经核实后将做以下处理：会刊资料中涉及侵权风险的产品部分，对产品名称予以删除；禁止在展会现场展示宣传该涉及侵权风险的产品，否则由此产生的一切法律纠纷及责任由参展单位自行承担；</div>
          <div>4、展览会期间发生在展馆现场各参展单位之间的投诉，原则上由当事人协商解决。不愿协商或者协商不成的，知识产权人或者利害关系人可以向知识产权局投诉，或向人民法院起诉，也可以请求工商行政管理部门处理。展览会组委会有责任配合以上权力部门取证。</div>
          <div>5、展览会组委会将遵循“友好调解、专家认定、协调裁定”的原则，公开、公平、公正地处理在本届展会期间发生在展馆现场的各参展单位之间的涉嫌侵犯知识产权的案例。</div>
          <div>6、对擅自与涉嫌侵权方进行交涉，在展馆现场引起纠纷而影响展览会秩序的单位及人员，展览会组委会及保卫办公室有权禁止其进入或令其退出展馆。</div>
          <div style="padding:10px 0 0"><el-checkbox v-model="xyCheckBox">确认知悉以上规定并承担一切法律后果</el-checkbox></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipOk"  :disabled='!xyCheckBox'>确认并前往会刊填写页面</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '../utils/tools.js';
import {validAddress,validComName,validComEName,validZipCode,validTel,validEmail, validateMobile } from '@/utils/validator'
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tagProps: {
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'childs'
      },
      saveBtnStatue:true,  //保存铵钮状态
      Dsave:true,  //保存铵钮状态
      tagOptions: [],
      countryList: [],    //国家
      provinceList: [],  //省份
      cityList: [],    //城市
      form: {},
      rules: {},
      allList:[],
      isPC: true,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      dialogVisible:false,
      xyCheckBox:false,
      isClose:false,
      isBody:true,
      clgID:'',
      isShowContactInfo: false
    }
  },

  components: {
    Upload
  },
  async mounted() {
    this.getsaasfield()
    this.getCountrys()
    this.getallprovinces()
    this.getStype()
  },
  methods: {
    tipOk(){
      if(this.xyCheckBox){
        this.dialogVisible = false
      }
    },
    validateProvince (rule, value, callback) {
      if (rule.required) { // 如果省份必填
        if (this.form.clgCountry === '中国' || this.form.clgCountry === undefined) { // 已选择中国或没有国家选项
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateCity (rule, value, callback) {
      if (rule.required) {
        if (this.form.clgProvince) {
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
     validateclgName (rule, value, callback) {
       if(value || rule.required){
          if (!validComName(value)) {
           callback(new Error(rule.message))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
    validateclgEName (rule, value, callback) {
       if(value || rule.required){
          if (!validComEName(value)) {
           callback(new Error(rule.message))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
     validateclgSName (rule, value, callback) {
       if(value || rule.required){
          if (value.length > 50) {
           callback(new Error('公司简称长度不能超过50字符！'))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
    validateclgESName (rule, value, callback) {
       if(value || rule.required){
          if (value.length > 50) {
           callback(new Error('公司简称长度不能超过50字符！'))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
    validateclgZipCode(rule, value, callback) {
      if(value || rule.required){
        if (!validZipCode(value)) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      }else{
        callback()
      }
    },
    validateEmail (rule, value, callback) {
      if(value || rule.required){
        if (!validEmail(value)) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      }else{
        callback()
      }
    },
    validateAddress  (rule, value, callback) {
      if(value || rule.required){
        if (!validAddress(value)) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      }else{
        callback()
      }
    },
    validateTel  (rule, value, callback) {
      if(value || rule.required){
        if (!validTel(value)) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      }else{
        callback()
      }
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        clgIfShowEmail: [{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName}],
        clgCountry: [{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName}],
        clgProvince:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateProvince}],
        clgCity:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateCity}],
        clgZipCode: [{ required: item.required, trigger: 'change',  message: "请输入正确"+item.fieldName, validator: this.validateclgZipCode }],
        clgAddress: [{ required: item.required, trigger: 'change',  message: item.fieldName+'请输入6-200字符', validator: this.validateAddress }],
        clgLogo: [{ required: item.required, trigger: 'change',  message: '请上传'+item.fieldName}],
        clgFax: [{ required: item.required, trigger: 'change', message: "请输入正确"+item.fieldName,validator: this.validateTel}],
        clgTel: [{ required: item.required, trigger: 'change', message: "请输入正确"+item.fieldName,validator: this.validateTel}],
        clgMobile: [{ required: item.required, trigger: 'change', message: "请输入正确"+item.fieldName, validator: validateMobile }],
        clgComName: [{ required: item.required, trigger: 'change',message: item.fieldName+'请输入4-200字符', validator: this.validateclgName }],
        clgComEName: [{ required: item.required, trigger: 'change',message: item.fieldName+'请输入2-200字符', validator: this.validateclgEName }],
        clgComSName: [{ required: item.required, trigger: 'change',message: item.fieldName+'请输入100字符以内', validator: this.validateclgSName }], // 公司中文简称
        clgComESName: [{ required: item.required, trigger: 'change',message: item.fieldName+'请输入100字符以内', validator: this.validateclgESName }], // 公司英文简称
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'},
        clgEmail: [{ required: item.required, trigger: 'change', message: "请输入正确"+item.fieldName, validator: this.validateEmail}],
      }
      switch (item.fieldKey){
        case 'clgCountry':
        case 'clgProvince':
        case 'clgCity':
        case 'clgEmail':
        case 'clgZipCode':
        case 'clgComName':
        case 'clgComEName':
        case 'clgComSName':
        case 'clgComESName':
        case 'clgTel':
        case 'clgMobile':
        case 'clgFax':
        case 'clgLogo':
            temp = item.fieldKey
            break;
        case 'clgAddress':
        case 'clgEAddress':
            temp = 'clgAddress'
            break;
        default: 
            temp = 'other'
            break
      }
      return rulesData[temp]
    },
    getsaasfield(){
      api.getsaasfield({type:"catalog"}).then(res => {
        if (res.data.code === 200) {
          this.allList =[]
          var _data = res.data.data
          for(var i = 0;i<_data.length;i++){
            if(_data[i].enable == 1){
              this.allList.push(_data[i])
            }
          }
          for(var j=0;j<this.allList.length;j++){
            this.$set( this.form,this.allList[j].fieldKey,"")
          }
          this.$nextTick(() => {
            this.getData()
          })
        }
      })
    },
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.form[val] = this.form[val].replace(/[^\d]/g,'');
    },
    getClass(arr,val){
      var temp = [];
      function getSelectVal(_arr,_id){
        for(var i=0;i<_arr.length;i++){
          if(_arr[i].childs && _arr[i].childs.length>0){
            getSelectVal(_arr[i].childs,_id)
          }
          if(_arr[i].id == _id){
            var _temp = []
            if(_arr[i].gpId){
              _temp.push(_arr[i].gpId)
            }
            if(_arr[i].pId){
              _temp.push( parseInt(_arr[i].pId))
            }
            _temp.push(_arr[i].id)
            temp.push(_temp)
          }
        }
      }
      getSelectVal(arr,val)
      return temp
    },
    //获取主营产品分类  并且赋值
    getStype(val){
      api.getexhibitstype().then((res) => {
        this.tagOptions = this.removeEmptyChild(res.data.data)
        var select = []
        if(val && val !='' ){
          select = val.split(",")
        }
        if(select.length>0){
          var _temp = []
          for(var j=0;j<select.length;j++){
            _temp.push( ...this.getClass(this.tagOptions,select[j]) )
          }
          this.form.clgPdtType =  _temp
        }
      })
    },
    //获取国家选项
    getCountrys() {
      api.getallcountrys({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
      })
    },
    //国家切换
    changeCountry(){
      if(this.form.clgCountry !='中国'){
        this.form.clgProvince= ''
        this.form.clgCity =''
        this.cityList =[]
        this.provinceList =[]
      }else{
        api.getallprovinces().then((res) => {
          this.provinceList = res.data.data
        })
        this.getCity()
      }
    },
    //切换省份
    changeProvince(){
      this.form.clgCity =''
      this.getCity()
    },
    //跟据省份获取城市
    getCity(){
      if( this.form.clgProvince && this.form.clgProvince !=""){
        api.getallcitysbyprovince({zptProvince:this.form.clgProvince}).then((res)=>{
          this.cityList = res.data.data
        })
      }else{
        this.cityList = []
      }
    },
    // 获取所有省份
    getallprovinces() {
      api.getallprovinces().then((res) => {
        this.provinceList = res.data.data
      })
    },
    //获取会刊信息
    getData(){
      return new Promise((resolve, reject)=>{
        api.getcatalogdetail().then((res)=>{
          if(res.data.code =='200' && res.data.data){
            var _data = res.data.data
            this.clgID = res.data.data.clgID
            // console.log(this.form,'406')
            for (let i in this.form) {
              this.form[i] = _data[i]?''+_data[i]+'':''
            }
            this.form = JSON.parse(JSON.stringify(this.form))
            // 多选框的提交
            // if (_data.clgIfShowEmail === '1') {this.isShowContactInfo = true}
            // else{this.isShowContactInfo = false}
            if(this.form.hasOwnProperty("clgPdtType")){
              this.getStype(this.form.clgPdtType) 
            }
                    
            api.getallcountrys().then((res) => {      
              this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
            })
            if ((this.form.clgCountry && this.form.clgCountry === '中国') || this.form.atrCountry===undefined) {
              this.getallprovinces()
              this.getCity()
            }else{
              this.provinceList = [];
              this.citysList= [];
            }
            this.saveBtnStatue = false
            if (_data.clgSysState === '正常') {
              this.Dsave = true
            } else {
              this.Dsave = false
            }
            resolve(_data.clgPdtType)
          }else{
            this.dialogVisible = true
            this.form.clgComEName = this.userInfo.atrEName
            this.form.clgComName = this.userInfo.atrName
            this.saveBtnStatue = false
            this.Dsave = false
            // this.pullcatalog()
            reject("")
          }
        })
      })
    },
    pullcatalog(){
      // console.log(this.form)
      if(this.clgID !=''){
        this.$notify({
          title: '上届会刊信息已拉取',
          type: 'success',
          duration: 2000
        })
        return false
      }
      return new Promise((resolve, reject)=>{
        api.pullcatalog().then((res)=>{
          if(res.data.code =='200'){
            this.getData()
            resolve(_data.clgPdtType)
          }else{
            // reject("")
          }
        })
      })
    },
    textChange(){
      // console.log(keyText)
      for(var i = 0;i<keyText.length;i++){
        this.form.clgIntro = this.form.clgIntro.replace(new RegExp(keyText[i],'g'),'')
      }
      // console.log(this.form.clgIntro,'2')
    },
    onSubmit(IsCache) {
      if( this.saveBtnStatue ){
        return false
      }
      for (let i in this.form) {
        if( typeof this.form[i] != 'object'){
          this.form[i] = (this.form[i]).toString().replace(/^\s+|\s+$/g,"")
        }
      }
      // if (!this.isShowContactInfo) {this.form.ClgIfShowEmail = '0'}  // 多选框的提交
      // else{this.form.ClgIfShowEmail = '1'} // 是否在电子会刊里展示邮箱（0或1,1 是显示 邮箱，0 是不显示邮箱）
      this.$refs['magezineForm'].validate((valid) => {
        if (valid) {
          var paramt = JSON.parse(JSON.stringify(this.form))
          var tempArry = []
          if (paramt.clgPdtType) {
            for(var i=0;i<paramt.clgPdtType.length;i++){
              var _arr = paramt.clgPdtType[i]
              tempArry.push( _arr[_arr.length-1])
            }
            paramt.clgPdtType = tempArry.join(",")
          }
          paramt.clgBthCode =  JSON.parse(localStorage.getItem('userInfo')).bthCode
          paramt.IsCache = IsCache
          this.saveBtnStatue = true
          api.savecatalog(paramt).then((res) => {
            if (res.data.code === 200) {
              if(IsCache === ""){
                this.$confirm('<span style="font-size:18px">请继续填写主要产品</span>', '提示', {
                  confirmButtonText: '确定',
                  type: 'none',
                  showCancelButton:false,
                  closeOnClickModal:false,
                  closeOnPressEscape:false,
                  dangerouslyUseHTMLString:true,
                  showClose:false,
                  center: true
                }).then(() => {
                  this.$router.push(`/product`)
                })
              }
              this.$notify({
                title: '提交成功',
                type: 'success',
                duration: 2000
              })
            }
            this.saveBtnStatue = false
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false
        }
      })
    },
    // 因后端API不支持，需前端处理数据结构，仅支持三级，写死去掉最后childs为空的属性
    removeEmptyChild(data) {
      let types = data.map((element) => {
        if (element.childs.length === 0) {
          delete element.childs
        } else {
          element.childs.map((item) => {
            if (item.childs.length === 0) {
              delete item.childs
            } else {
              item.childs.map((_item) => {
                if (_item.childs && _item.childs.length === 0) {
                  delete _item.childs
                }
                return _item
              })
            }
            return item
          })
        }
        return element
      })
      return types
    }
  }
}
</script>
<style lang="less">
.magezine{
  .el-form-item.is-error .clearError input.el-input__inner{
    border: 1px solid #DCDFE6 !important;
  }
  .blue {
    color: #409eff;
  }

  .title {
    margin-bottom: 30px;
  }

  .col-1-fix {
    padding-left: 0 !important;
  }
}
.tipContent div{
  font-size:14px;
  line-height: 30px;
}
.clgLogo .el-form-item__label{
  position: relative;
}
.clgLogo .el-form-item__label::after{
  content:'（logo用于企业名片）';
  position: absolute;
  right: 10px;
  top:20px;
}
@media screen and (max-width:540px){
  .magezine{
    .el-form-item__error{
      width: 100%;
      text-align: right;
    }
    .el-form-item__label{
      font-size:14px;
    }
    .el-input__inner{
      border:0;
      text-align: right;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:180px;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width:10px;
    }
    .cccItem{
      border:0;
      margin:0;
      .el-form-item__error{
        top: 240%
      }
    }
    .pad0{
      padding-right:0 !important;
    }
    .telOrFax{
      padding:0 24px;
      .el-input__inner{
        padding:0;
        border: 1px solid #ededed;
        text-align: center;
      }
    }
  }
}
</style>
